import * as React from 'react';
import Box from "@mui/material/Box";
import { StoreContext } from '../../store/StoreProvider';
// import { types } from '../../store/Dialog';
import { getI18N } from '../../i18n'
import { ClientCard } from '../App/ClientCard';
import { Button, MenuItem } from "@material-ui/core";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import InputBase from "@mui/material/InputBase";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { IconQr } from '../icons/IconQr';
import { IconSearch } from "../icons/IconSearch";
import Loading from "../Loading";
import { Scanner } from "./Scanner";
import AddIcon from '@mui/icons-material/Add';
import { IconTrash } from "../icons/IconTrash";
import { DisplaySelects } from './DisplaySelects';
import { Menu } from '@mui/material';
import { types } from '../../store/Clients';
import { MultiInput } from "../MultiInput";
import TextField from '@mui/material/TextField';
import { Alert } from "../Alert";

import {
  CorpGetDetailByMinicod,
  CorpPostWarrantyCardSell

} from "../../store/sagas/Warranty";

interface HomeManagementProps { }

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const HomeManagementComponent = (props: HomeManagementProps) => {

  const [store, dispatch] = React.useContext(StoreContext);

  const AlertRef = React.useRef<any>();

  const { Country } = store?.user;
  const currentLocale: string = Country || "PE";
  const i18n = getI18N({ currentLocale })

  const [codeCorpList, setCodeCorpList] = React.useState<string[]>([]);
  const [searchCode, setCode] = React.useState("");
  const [loadingCodeCorp, setLoadingCodeCorp] = React.useState(false);
  const [managementType, setManagementType] = React.useState<number>(1);

  const [loading, setLoading] = React.useState(false);
  const [loadingSearch, setLoadingSearch] = React.useState(false);
  const [searchType, setSearchType] = React.useState<number>(0);

  const [scan_qr, setScan] = React.useState(false);

  const [clientName, setClientName] = React.useState('');
  const [clientNroDocument, setClientNroDocument] = React.useState('');
  const [clientPhone, setClientPhone] = React.useState('');

  const handleChange = (value: number) => {
    // dispatch({ type: types.change_tab, payload: managementType });

    const managementTypeValue:number = value;

    if( [2,3].includes(managementTypeValue) ){
      if (clientName.trim() === "") {
        return AlertRef?.current?.open("Ingrese el nombre del cliente", "error");
      }

      if (clientNroDocument.trim() === "") {
        return AlertRef?.current?.open("Ingrese el DNI / RUC del cliente", "error");
      }

      if (clientPhone.trim() === "") {
        return AlertRef?.current?.open("Ingrese el teléfono del cliente", "error");
      }
    }

    if (managementTypeValue === 2) {

      if (codeCorpList?.length <= 0) {
        return AlertRef?.current?.open("No existen codigos agregados", "error");
      }

      setLoading(true);

      const arBaterias = codeCorpList.map((code) => {
        return {
          Minicod: code
        }
      })

      const dataRequest = {
        // Cardcode: store?.user?.cardCode2,
        Cardcode: store?.selected_client?.UserId,
        NombreCliente: clientName.trim(),
        NroDocumento: clientNroDocument.trim(),
        NroTelefono: clientPhone.trim(),
        Baterias: arBaterias
      }

      CorpPostWarrantyCardSell(dataRequest).then((response) => {
        setLoading(false);
        if (response?.statusCode !== 200) {
          return AlertRef?.current?.open(response?.message ?? "Ocurrio un error", "error");
        }

        dispatch({ type: types.managementType, payload: managementTypeValue });
      })

      return false;
    }

    const clientData = {
      clientName: clientName?.trim(),
      clientNroDocument: clientNroDocument.trim(),
      clientPhone: clientPhone.trim()
    }

    dispatch({ type: types.managementType, payload: managementTypeValue, client: managementTypeValue === 3 ? clientData : {} });
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value?: number) => {
    if (value !== undefined) {
      setManagementType(value);

      setClientName('');
      setClientNroDocument('');
      setClientPhone('');

    }
    setAnchorEl(null);
  };

  const addCodeBattery = (e: any|undefined = undefined) => {
    e?.preventDefault();

    if (searchCode.trim() === "") {
      return AlertRef?.current?.open("Ingrese un código válido", "error");
    }

    if (codeCorpList?.length >= 10) {
      return AlertRef?.current?.open("Solo se permiten 10 códigos de baterias", "error");
    }

    const existCode = codeCorpList?.findIndex((code) => code === searchCode);

    if (existCode >= 0) {
      return AlertRef?.current?.open("El código ya se encuentra agregado", "error");
    }

    const objRequest = {
      QRcode: searchCode?.toLocaleUpperCase(),
      OrigenBat: store?.user?.Country
    }

    setLoadingCodeCorp(true);

    CorpGetDetailByMinicod(objRequest).then((response) => {

      setLoadingCodeCorp(false);

      if (response?.statusCode !== 200) {
        return AlertRef?.current?.open(response?.message ?? "Ocurrio un error al validar el codigo", "error");
      }

      if (response?.statusCode === 200) {
        setCodeCorpList([...codeCorpList, (searchCode?.toLocaleUpperCase())]);
      }
      setCode("");
    })
  };

  const handleRemoveCode = (index: number) => {
    const newElements = codeCorpList.filter((_, i) => i !== index);
    setCodeCorpList(newElements);
  };

  const scanToggle = (e: any) => {
    e.preventDefault();
    setScan(!scan_qr);
  };

  return (
    <Box className="home-management-container">
      <Alert ref={AlertRef} />
      <Grid container columnSpacing={{ xs: 2, sm: 2, md: 2 }} style={{ justifyContent: "center", alignItems: "center" }}>
        <Grid item xs={6}>
          <Button
            variant={managementType === 1 ? "contained" : 'outlined'}
            className="btn-primary rounded-button"
            color={managementType === 1 ? "primary" : 'default'}
            style={{ borderRadius: "20px", fontWeight: "bold", maxWidth: "100%", minWidth: "50%" }}
            onClick={() => {
              setManagementType(1)
              handleChange(1)
            }}
            disabled={false}
          >
            Gestión de flota
          </Button>
        </Grid>

        <Grid item xs={6}>

          <Button
            variant={managementType === 2 || managementType === 3 ? "contained" : 'outlined'}
            className="btn-primary rounded-button"
            color={managementType === 2 || managementType === 3 ? "primary" : 'default'}
            style={{ borderRadius: "20px", fontWeight: "bold", maxWidth: "100%", minWidth: "50%" }}
            onClick={handleClick}
            disabled={false}
          >
            SOCIO CORPORATIVO <KeyboardArrowDownIcon />
          </Button>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose()} style={{ width: 200 }} sx={{ width: anchorEl?.offsetWidth }} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{
              style: {
                width: '100%',
                minWidth: "100%",
                maxWidth: "100%",
              },
            }}>
            <MenuItem key={Math.random()} selected={managementType === 2} onClick={() => handleClose(2)}>Venta</MenuItem>
            <MenuItem key={Math.random()} selected={managementType === 3} onClick={() => handleClose(3)}>Taller</MenuItem>
          </Menu>
        </Grid>
      </Grid>

      {[2, 3].includes(managementType) && <Box marginBottom={"1rem"} style={{ marginTop: "1rem", padding: "4vh 2vw" }} sx={{ flexGrow: 1, padding: "0.8rem" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} style={{ padding: "1rem", background: "#FFFFFF", borderRadius: "15px" }}>

            <Box style={{ padding: '1rem' }} >

              <Grid container spacing={1} style={{ backgroundColor: '#F1F1EF', borderRadius: '15px', padding: '0.5rem' }} >
                <Grid item xs={12}>
                  <TextField label={'Nombre'} fullWidth value={clientName} onChange={(e) => {
                    setClientName(e.target.value)
                  }}></TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField label={'DNI / RUC'} fullWidth type='number' value={clientNroDocument} onChange={(e) => {
                    setClientNroDocument(e.target.value)
                  }}></TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField label={'TELEF.'} fullWidth type='number' value={clientPhone} onChange={(e) => {
                    setClientPhone(e.target.value)
                  }}></TextField>
                </Grid>
              </Grid>

            </Box>

            {managementType === 2 && <Box>
              <div className="input-container">
                <Paper
                  component="form"
                  className="form-input-custom"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <InputBase
                    className="uppercase"
                    sx={{ ml: 1, flex: 1 }}
                    placeholder={i18n.BATTERY_CODE}
                    inputProps={{ "aria-label": `${i18n.BATTERY_CODE}` }}
                    value={searchCode}
                    onChange={(event) => {
                      setCode(event.target.value.toLocaleUpperCase())
                    }}
                    onSubmit={(e) => {
                      e.preventDefault();
                      // setSearchType(1);
                    }}
                  />
                  <IconButton
                    onClick={scanToggle}
                    sx={{ p: "10px" }}
                    aria-label="Leer código QR"
                    disableFocusRipple={true}
                    disabled={false}
                  >
                    <IconQr />
                  </IconButton>
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="Buscar código"
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      setSearchType(1);
                      addCodeBattery(e);
                    }}
                  >
                    <Loading loading={loadingCodeCorp && searchType === 1}>
                      <IconSearch />
                    </Loading>
                  </IconButton>
                  {
                    store?.userAppCorp && !store.openCreateWarrantyRequest ? (<Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />) : <></>
                  }
                  {
                    store?.userAppCorp && !store.openCreateWarrantyRequest ? (
                      <IconButton
                        onClick={(e) => {
                          setSearchType(2);
                          addCodeBattery(e);
                        }}
                        sx={{ p: "10px" }}
                        aria-label="Agregar Código"
                        disableFocusRipple={true}
                        style={{ color: "#000" }}
                      >
                        <Loading loading={loadingCodeCorp && searchType === 2}>
                          <AddIcon />
                        </Loading>

                      </IconButton>
                    ) : <></>
                  }

                </Paper>
              </div>
              {!!scan_qr && (
              <div className="scanner-container">
                <Scanner
                  callback={(res: any) => {
                    let code = res;
                    if (res.length > 6 && res.indexOf("=") !== -1) {
                      code = res.split("=")[1];
                    }

                    if (code !== '') {
                      setScan(false);
                      setCode(code)
                    }
                    
                    addCodeBattery();
                  }}
                />
              </div>
            )}

              <Box sx={{ flexGrow: 1, padding: "0.8rem" }} className="container-body-action-corp">
                <Paper variant="outlined" style={{ borderColor: "#000000", borderRadius: "15px" }}>

                  {
                    codeCorpList?.map((codeItem, index: number) => {
                      return (
                        <Box sx={{ flexGrow: 1 }} className="item-codigo" key={index}>
                          <Grid container spacing={2} columns={16} justifyContent="start" alignItems="center">
                            <Grid item xs={12}>
                              <h3 style={{ margin: "0" }}>{codeItem}</h3>
                            </Grid>
                            <Grid item xs={4}>
                              <IconButton
                                onClick={() => {
                                  handleRemoveCode(index)
                                }}
                                sx={{ p: "10px" }}
                                aria-label=""
                                disableFocusRipple={true}
                                style={{ color: "#000" }}
                                color="primary"
                              >
                                <IconTrash />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Box>
                      )
                    })
                  }

                  {/* <Box sx={{ flexGrow: 1 }} className="item-codigo" key={0}>
                    <Grid container spacing={2} columns={16} justifyContent="start" alignItems="center">
                      <Grid item xs={12}>
                        <h3 style={{ margin: "0" }}>CODIGO001</h3>
                      </Grid>
                      <Grid item xs={4}>
                        <IconButton
                          onClick={() => {
                            // handleRemoveCodeShipt(index)
                          }}
                          sx={{ p: "10px" }}
                          aria-label=""
                          disableFocusRipple={true}
                          style={{ color: "#000" }}
                          color="primary"
                        >
                          <IconTrash />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box> */}

                </Paper>
              </Box>
            </Box>}

            <Grid item xs={12} style={{ padding: "1rem" }}>
              <Button
                variant="contained"
                className="btn-primary rounded-button"
                color="primary"
                style={{ borderRadius: "20px", fontWeight: "bold", maxWidth: "100%", minWidth: "50%", marginBottom: '1rem' }}
                onClick={() => {
                  handleChange(managementType)
                }}
                disabled={loading}
              >
                <Loading loading={loading}>
                  {managementType === 3 ? 'Iniciar Registro' : 'Guardar'}
                </Loading>

              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box >}
    </Box >
  );
};

